import PlataformaNavbar from './components/PlataformaNavbar';
import PlataformaHero from './components/PlataformaHero';
import PlataformaModulos from './components/PlataformaModulos';
import PlataformaRecursos from './components/PlataformaRecursos';
import PlataformaDiferencial from './components/PlataformaDiferencial';
import PlataformaFooter from './components/PlataformaFooter';

export default function PlataformaPage() {
  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <PlataformaNavbar />
      <main>
        <PlataformaHero />
        <PlataformaModulos />
        <PlataformaRecursos />
        <PlataformaDiferencial />
      </main>
      <PlataformaFooter />
    </div>
  );
}